<template>
  <div class="brand-card">
    <div class="brand-card__logo">
      <picture>
        <source
          media="(max-width: 767px)"
          :srcset="_.get(brand, 'logo[0].devices.mobile')"
        />
        <source
          media="(max-width: 1023px)"
          :srcset="_.get(brand, 'logo[0].devices.tablet')"
        />
        <img :src="_.get(brand, 'logo[0].devices.desktop')" alt />
      </picture>
    </div>
    <div class="brand-card__content">
      <div class="title font-23 bold">{{ _.get(brand,'front_title') }}</div>
      <!-- <div class="cat-cont">
        <div
          class="categories text-overflow-hidden-2"
          v-html="brand.description"
        >
          {{ brand.description }}
        </div>
      </div> -->

      <div class="brand-card__content-bottom flex al-center between">
        <div class="row bold">
          {{ $fn.tr("სართული") + ": " }}

          <span
            :key="indx"
            v-for="(item, indx) in getFloor(_.get(brand, 'floor'))"
            >{{
              _.get(item, "title") +
                `${
                  indx == getFloor(_.get(brand, "floor")).length - 1 ? "" : ","
                }`
            }}
          </span>
        </div>
        <div
          class="row flex al-center bold uppercase pointer visit"
          @click.stop="goToLink"
        >
          {{ $fn.tr("ვიზიტი") }}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7.857"
            height="10"
            viewBox="0 0 7.857 10"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(-12 -7.5)"
              fill="#4d4d4f"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["contentData", "brand"],
  computed: {
    cats() {
      return _.get(
        this.$store.state.main.indx,
        "terms.store_categories"
      ).filter(cat => _.get(this.brand, "store_categories").includes(cat.id));
    }
  },
  methods: {
    goToLink() {
      setTimeout(() => {
        this.$store.commit("main/setState", {
          key: "store_pop_up",
          val: false
        });
        document.body.classList.remove("ov_hidden");

        this.$router.push(this.$store.getters["main/getSingleUrl"](this.brand));
      }, 100);
    },
    getFloor(floorId) {
      const floorWidget = this.$store.state.main?.indx?.terms?.floors;
      const res = [];
      floorId.length
        ? floorId.forEach(floor => {
            res.push(floorWidget.find(item => item.id == floor));
          })
        : "";
      // console.log(res, "res");
      return res;
    }
  }
};
</script>

<style lang="scss" scoped>
.brand-card {
  background: $white;
  padding: 0 30px 40px 30px;
  transition: 0.4s ease;
  cursor: pointer;
  border: 2px solid;
  border-color: transparent;

  &:hover {
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
    transform: translateY(-5px);
    border-color: #1a1a1a;
  }
  &__logo {
    height: 143px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 2px solid #f7f7f7;
    position: relative;
    img {
      position: absolute;
      width: 75%;
      height: 70%;
      object-fit: contain;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @media (max-width: 767px) {
        height: 100%;
      }
    }
  }
  &__content {
    padding: 36px 0 0;
    .cat-cont {
      min-height: 56px;
      margin-bottom: 10px;
      display: flex;
      flex-wrap: wrap;
      .categories {
        height: 40px;
        @media (max-width: 1440px) {
          height: 32px;
        }
      }
    }
    .title {
      margin-bottom: 15px;
    }
  }
  &__content-bottom {
    .visit {
      transition: 0.4s ease;
      svg {
        path {
          transition: 0.4s ease;
        }
      }
      &:hover {
        color: $red;
        svg {
          path {
            fill: $red;
          }
        }
      }
    }
    .row {
      &:last-child {
        svg {
          margin-left: 10px;
        }
      }
    }
    span {
      &:last-child {
        i {
          display: none;
        }
      }
    }
  }
}
</style>
